import React, {useState, useEffect, useContext} from "react"
import { RootContext } from "../../context/beltContext"

const CartInventoryCount = () => {

    let [inventoryCount, setInventoryCount] = useState(0)
    let { skus } = useContext(RootContext)
    
    useEffect(() => {
        let curCart = typeof window !== undefined && window.localStorage.getItem('cart')
        curCart = JSON.parse(curCart)
        if(!!curCart){
            let counter = 0
            for (const item in curCart) {
                counter += curCart[item].qty
            }
            setInventoryCount(counter)
            
        }
        console.log('Updating cart counter:', inventoryCount)
    }, [skus])

    if (inventoryCount > 0) {
        return(
            <div className='position-absolute bg-yellow circle w-50 h-50 d-flex' style={{top: '-10%', right: '-10%'}}>
                <p className="font-xs text-white text-center m-auto">{inventoryCount}</p>
            </div>
        )
    }
    else return <></>
}

export default CartInventoryCount;